<template>
    <Card :title="$t('crm-setting.pipeline.activityType.list')" containerClass="mb-5">
      <template #cardToolbar>
        <div class="d-flex justify-content-end align-items-center">
          <div>
            <Button type="new" v-if="$can(abilities.CREATE_TYPE_ACTIVITY)" btn-class="me-3 btn-sm" btn-text="crm-setting.pipeline.activityType.create"  @click="openTypeModal" ></Button>
          </div>
        </div>    
      </template>
      <template #cardBody>
        <InfoAlert :text="$t('crm-setting.pipeline.activityType.alert_text')"/>
        <div class="row">
          <Draggable :title1="$t('crm-setting.pipeline.activityType.title2')" :title2="$t('crm-setting.pipeline.activityType.title1')" @statusChange="handleStatusChange">
            <template #container1>
              <div
                v-for="item in inactiveActivityTypes"
                :key="item.id"
                :data-id="item.id"
                class="draggable"
              >
                <TypeItem :color="item.color" containerClass="mb-2" :label="item.name" :icon="item.icon" @actionUpdate="updateType(item)" @actionDelete="deleteType(item.id)"/>
              </div>
            </template>
            <template #container2>
              <div
                v-for="item in activeActivityTypes"
                :key="item.id"
                :data-id="item.id"
                class="draggable"
              >
                <TypeItem :color="item.color" containerClass="mb-2" :label="item.name" :icon="item.icon" @actionUpdate="updateType(item)" @actionDelete="deleteType(item.id)"/>
              </div>
            </template>
          </Draggable>
        </div>
      </template>
    </Card>

  <CreateType id="create" @load="loadData"></CreateType>
  <CreateType id="edit" :isEdit="true" :type="formUpdateData" @load="loadData"></CreateType>
</template>

<script setup>
import {ref, onMounted, computed} from 'vue'
import CreateType from "@/Modules/CRM/components/Modals/ActivityType/CreateType.vue";
import TypeItem from "@/Modules/CRM/components/ActivityTypeItem";
import Draggable from "@/Modules/CRM/components/Draggable";
import {useStore} from "vuex";
import i18n from "@/plugins/i18n";
import Button from "@/components/Button";
import Card from "@/Modules/CRM/components/Card";
import InfoAlert from "@/components/InfoAlert"
import {useSwal} from "@/composables/useSwal";
import abilities from "@/composables/abilities";

const {showSwal} = useSwal()
const store = useStore()

const formUpdateData = ref({
  id: '',
  name: '',
  icon: '',
  color: ''
})

const activityTypes = computed(() => store.getters['activityTypes/getActivityTypes'])
const activeActivityTypes = computed(() => Object.values(activityTypes.value).filter((item) => item && item.active == true))
const inactiveActivityTypes = computed(() => Object.values(activityTypes.value).filter((item) => item && item.active == false))

function openTypeModal (){
  $('#createTypeModal_create').modal('toggle')
}

function updateType(item){
  formUpdateData.value.id = item.id
  formUpdateData.value.name = item.name
  formUpdateData.value.icon = item.icon
  formUpdateData.value.color = item.color
  $('#createTypeModal_edit').modal('toggle')
}

async function deleteType(id){
  showSwal(
    i18n.global.t('crm-setting.pipeline.activityType.swal.title'),
    i18n.global.t('crm-setting.pipeline.activityType.swal.deleted')
  ).then( async (result) => {
    if (result.value) {
      try {
        await store.dispatch('activityTypes/deleteActivityType', id)
        loadData()
        window.toastr['success'](i18n.global.t("notification.activityType_deleted"))
      }catch (e) {
      }
    }
  });
}

function handleStatusChange(id) {
  let data = Object.values(activityTypes.value).filter((item) => item.id == id)
  let form = {
    id: data[0].id,
    name: data[0].name,
    color: data[0].color,
    icon: data[0].icon,
    active: !data[0].active
  }

  store.dispatch('activityTypes/updateActivityTypeStatus', form)
      .then((response) => {
        loadData()
        window.toastr['success'](i18n.global.t('notification.activityType_changed_status'))
      })
}

function loadData(){
  store.dispatch('activityTypes/loadActivityTypes')
}

onMounted(() => {
  loadData()
})
</script>